import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticatedSelector } from 'Store/modules/auth/selectors';

import { userStageSelector } from 'Store/modules/validations/selectors';
import { pathNameSelector } from 'Store/modules/router/selectors';
import { publicPath, routes } from 'Constants/routes';
import { PrivateRouteProps } from './types';

const PrivateRoute = ({
  component: Component,
  stage,
  type,
  ...rest
}: PrivateRouteProps): JSX.Element => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const userStage = useSelector(userStageSelector);
  const pathName = useSelector(pathNameSelector);

  if (!isAuthenticated) {
    if (pathName === publicPath) {
      return <Redirect to={routes.SIGNUP} />;
    }
    return <Redirect to={routes.SIGNIN} />;
  }
  if (stage && userStage !== stage) {
    return <Redirect to={routes.DASHBOARD} />;
  }

  return <Route {...rest} exact render={props => <Component {...props} type={type} />} />;
};

PrivateRoute.defaultProps = {
  stage: null,
};

export default PrivateRoute;
